import { render, staticRenderFns } from "./CreateEstatePlanningProducts.vue?vue&type=template&id=4b9e4df8"
import script from "./CreateEstatePlanningProducts.vue?vue&type=script&lang=js"
export * from "./CreateEstatePlanningProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports